module.exports = __webpack_public_path__ + "static/media/3 10 Tulleord Blastell er feil.1ce30d5f.mp3";